export default {
  title: "{{user}} paid for all the orders and closed the table.",
  description:
    'We automatically have to close the table when all orders are paid. Of course, you can order more if you want to 😋 Please click "Continue"',
  buttons: {
    continue: "Continue",
  },
};
